<script setup lang="ts">
import { IconoirProvider } from "@iconoir/vue";
import { RouterView } from "vue-router";
</script>

<template>
  <IconoirProvider
    :icon-props="{
      role: 'img',
    }"
  >
    <RouterView v-slot="{ Component }">
      <template v-if="Component">
        <component :is="Component"></component>
      </template>
    </RouterView>
  </IconoirProvider>
</template>
